import Fondo from "../assets/paq.png"
import { motion } from "framer-motion";

const QuienesSomos = () => {
    return (
        <div className="w-full h-auto md:h-[75vh] grid grid-cols-1 md:grid-cols-2 md:px-36">
            <motion.div
                className="w-full h-full flex flex-col justify-center text-left px-4 md:px-10 gap-4 text-sky-800"
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <h1 className="font-bold text-4xl">¿Quiénes somos?</h1>
                <p className="text-lg text-justify">
                    Somos expertos en empaque por lo cual nosotros garantizamos que el traslado de su producto será el idóneo y
                    no sufrirá daños cumpliendo al 100% con la satisfacción de nuestros clientes
                </p>
            </motion.div>
            <motion.div
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-contain bg-center bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${Fondo})` }}
            />
        </div>
    );
};
export default QuienesSomos;